import React, {useState} from "react";
import "../../assets/styles/Demo.css";

const Demo = () => {

    const [flag, setFlag] = useState(false);



  return (
    <>
      <main id="main" className="main">
        <section>
        <div class="container">
            <div class="content-bg">
                <h4 class="text-left user-heading"> User Management</h4>

                    <div class="row mt-4">

                        <div class="col-lg-12 col-sm-12">


                            <div class="mb-3 row">
                                <label for="select" class="col-sm-2 col-form-label"><b>Organization Level</b></label>
                                <div class="col-sm-6">
                                    <select class="form-select" aria-label="Default select example"> 

                                      
                                        <option selected>---select One ---</option>
                                        <option value="Government">Government</option>
                                        <option value="Insurance Unit">Insurance Unit</option>


                                    </select>
                                </div>
                            </div>

                            <div class="mb-3 row">
                                <label for="select" class="col-sm-2 col-form-label"><b>User Level</b></label>
                                <div class="col-sm-6">
                                    <select class="form-select" aria-label="Default select example">

                                        <option selected>---select One ---</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </div>
                            </div>



                                <div class="mb-3 row">
                                    <label for="select" class="col-sm-2 col-form-label"><b>State</b></label>
                                    <div class="col-sm-6">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected>---select State ---</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mb-3 row">
                                    <label for="select" class="col-sm-2 col-form-label"><b>District</b></label>
                                    <div class="col-sm-6">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected>---select District ---</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>

                                 <div class="mb-3 row">
                                    <label for="select" class="col-sm-2 col-form-label"><b>Sub-District</b></label>
                                    <div class="col-sm-6">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected>---select Sub-District ---</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="mb-3 row">
                                    <label for="select" class="col-sm-2 col-form-label"><b>Village</b></label>
                                    <div class="col-sm-6">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected>---select Village ---</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                    </div>
                                </div>





                        </div>

                    </div>

                    <h4 class="text-left  user-details-hd">User Details </h4>

                    <div class="user-details-bg">

                        <div class="row m-3">

                            <div class="col-lg-12 col-sm-12">

                                <div class="mb-3 row">
                                    <label for="inputname" class="col-sm-2 col-form-label"><b>Full Name</b></label>
                                    <div class="col-sm-1">
                                        <select class="form-select" aria-label="Default select example">
                                            <option selected>Dr.</option>
                                            <option value="1">Sri.</option>
                                            <option value="2">Sm.</option>
                                            <option value="3">Mrs.</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-5">
                                        <input type="text" class="form-control" id="inputname"/>
                                    </div>
                                </div>



                                  


                                    <div class="mb-3 row">
                                        <label for="inputname" class="col-sm-2 col-form-label"><b>Designation</b></label>
                                        <div class="col-sm-6">
                                            <select class="form-select" aria-label="Default select example">
                                                <option selected>--Select---</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </select>
                                        </div>

                                    </div>



                                    <div class="mb-3 row">
                                        <label for="Email" class="col-sm-2 col-form-label"><b>Email</b></label>
                                        <div class="col-sm-6">
                                            <input type="text" readonly class="form-control-plaintext" id="Email" value="email@example.com"/>
                                        </div>

                                    </div>

                                    <div class="mb-3 row">
                                        <label for="Mobile" class="col-sm-2 col-form-label"><b>Mobile No</b></label>
                                        <div class="col-sm-5">
                                            <input type="text" readonly class="form-control-plaintext" id="Mobile"/>
                                        </div>
                                        <div class="col-auto">
                                            <button type="submit" class="btn btn-primary mb-3">Send OTP</button>
                                          </div>

                                    </div>

                                    <div class="col-auto float-right">
                                        <button type="submit" class="btn btn-primary mb-3">Reset</button>
                                      </div>


                            </div>

                        </div>
                    </div>
            </div>
            </div>
        </section>
      </main>
    </>
  );
};

export default Demo;
